module.exports = __webpack_public_path__ + "img/AgeUpIcon2Active_ua.3e2ef66f.webp";